import { getService, postService, deleteService } from "../../axios/services";

const BASE_ENDPOINT = "PermissionCatalog";

export const getLocalUsers = ({ searchTerm, pageIndex, pageSize, cancelToken }) =>
  getService({
    endpoint: `${BASE_ENDPOINT}/users`,
    api: "v2",
    params: { SearchTerm: searchTerm, PageIndex: pageIndex, PageSize: pageSize },
    options: { cancelToken },
  });

export const getProfiles = ({ cancelToken } = {}) =>
  getService({
    endpoint: `${BASE_ENDPOINT}/profiles`,
    api: "v2",
    options: { cancelToken },
  });

export const getResources = ({ cancelToken } = {}) =>
  getService({
    endpoint: `${BASE_ENDPOINT}/resources`,
    api: "v2",
    options: { cancelToken },
  });

export const getUserProfiles = (userId, { cancelToken } = {}) =>
  getService({
    endpoint: `${BASE_ENDPOINT}/users/${userId}/profiles`,
    api: "v2",
    options: { cancelToken },
  });

export const getProfileUsers = (profileName, { cancelToken } = {}) =>
  getService({
    endpoint: `${BASE_ENDPOINT}/profiles/${profileName}/users`,
    api: "v2",
    options: { cancelToken },
  });

export const associateResourceToProfile = (profileName, resourceName) =>
  postService({
    endpoint: `${BASE_ENDPOINT}/profiles/${profileName}/resources/${resourceName}`,
    api: "v2",
  });

export const disassociateResourceFromProfile = (profileName, resourceName) =>
  deleteService({
    endpoint: `${BASE_ENDPOINT}/profiles/${profileName}/resources/${resourceName}`,
    api: "v2",
  });
